import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Values injected into the release's workflows at Confirm (UCH-296). Gated by
 * `releases:secrets:view` and audited on every call; null when nothing was
 * stored (release confirmed before UCH-296, RELEASE_SECRETS_KEY unset, or no
 * upload token was issued).
 */
export const getReleaseSecrets = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/secrets',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({
    data: z.object({
      apiUrl: z.string().nullable(),
      uploadToken: z.string().nullable(),
    }),
  }),
});
